import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { OptionNumberModule, OptionTextModule } from '../../options';
import { QuestionRadioComponent } from './question-radio.component';

@NgModule({
  imports: [QuestionModule, OptionNumberModule, OptionTextModule],
  declarations: [QuestionRadioComponent],
  exports: [QuestionRadioComponent]
})
export class QuestionRadioModule {}
